import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { Box, Link as MuiLink, Stack } from '@mui/material'
import { DateTime } from 'luxon'
import NextLink from 'next/link'
import { SingleInputDateRangePicker } from '~/components/common/SingleInputDateRangePicker'
import { TitleHeader } from '~/components/TitleHeader'

type Props = {
  title?: string
  titleComponent?: React.ReactNode
  backLink?: {
    href: string
    label: string
  }[]
  startDate: string
  endDate: string
  handleStartDateChange: (date: DateTime | null) => void
  handleEndDateChange: (date: DateTime | null) => void

  children?: React.ReactNode
}
export const DateRangePickerContainer: React.FC<Props> = ({
  title,
  titleComponent,
  backLink,
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
  children,
}) => {
  const startDateValue = DateTime.fromISO(startDate)
  const endDateValue = DateTime.fromISO(endDate)
  return (
    <Box
      sx={{
        m: 2,
        mt: 1,
      }}
    >
      <Box mb={3}>
        {backLink?.length && (
          <Stack direction="row" alignItems="center" gap={0.5} mb={0.5}>
            {backLink.map((link) => (
              <Stack key={link.href} direction="row" alignItems="center">
                <MuiLink href={link.href} component={NextLink} sx={{ textDecoration: 'none' }} variant="bodyM">
                  {link.label}
                </MuiLink>
                <ChevronRightIcon fontSize="inherit" />
              </Stack>
            ))}
          </Stack>
        )}
        <Stack direction="row" justifyContent="space-between" flexWrap="wrap" gap={2} alignItems="center">
          {titleComponent || (title && <TitleHeader title={title} align="start" variant="headingL" />)}

          <SingleInputDateRangePicker
            value={[startDateValue, endDateValue]}
            setStartDate={handleStartDateChange}
            setEndDate={handleEndDateChange}
          />
        </Stack>
      </Box>
      {children}
    </Box>
  )
}
